import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { SectionLabel } from '../components/SectionLabel';
import { CheckIcon, MailIcon, SmartphoneIcon, LockIcon } from 'lucide-react';
export function ProductSection() {
  return <section className="py-14 md:py-20 px-6 bg-midnight relative overflow-hidden" data-id="element-397">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-lavender/10 rounded-full blur-[100px] pointer-events-none" data-id="element-398" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-399">
        <FadeIn className="text-center mb-16" data-id="element-400">
          <SectionLabel text="What You Get — Instantly" data-id="element-401" />
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-warmwhite mb-6" data-id="element-402">
            The Anger Circuit Breaker
            <br data-id="element-403" />
            <span className="text-lavender" data-id="element-404">Complete Digital Guide</span>
          </h2>
        </FadeIn>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-405">
          {/* Mockup */}
          <FadeIn direction="right" className="w-full lg:w-5/12" data-id="element-406">
            <div className="relative mx-auto w-full max-w-[320px] aspect-[3/4] bg-midnight-light border border-rosegold/40 rounded-xl shadow-[0_0_40px_rgba(155,142,196,0.2)] overflow-hidden flex flex-col items-center justify-center p-8 text-center" data-id="element-407">
              <div className="absolute inset-0 bg-gradient-to-br from-midnight-light to-midnight z-0" data-id="element-408" />
              <div className="absolute top-0 left-0 w-full h-1 bg-rosegold z-10" data-id="element-409" />

              <div className="relative z-10 flex flex-col items-center" data-id="element-410">
                <div className="w-16 h-16 rounded-full border border-rosegold/30 flex items-center justify-center mb-6" data-id="element-411">
                  <span className="text-3xl" data-id="element-412">⚡</span>
                </div>
                <h3 className="font-playfair text-2xl font-bold text-rosegold mb-2 uppercase tracking-widest" data-id="element-413">
                  The Anger
                  <br data-id="element-414" />
                  Circuit
                  <br data-id="element-415" />
                  Breaker
                </h3>
                <div className="w-12 h-px bg-rosegold/50 my-4" data-id="element-416" />
                <p className="font-inter text-xs text-softgray uppercase tracking-widest" data-id="element-417">
                  The 55-Second Protocol
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Deliverables */}
          <FadeIn direction="left" className="w-full lg:w-7/12" data-id="element-418">
            <ul className="space-y-8 mb-12" data-id="element-419">
              <li className="flex items-start" data-id="element-420">
                <div className="mt-1 bg-teal-900/30 rounded-full p-1 mr-4 shrink-0" data-id="element-421">
                  <CheckIcon className="w-5 h-5 text-teal-400" data-id="element-422" />
                </div>
                <div data-id="element-423">
                  <h4 className="font-inter font-semibold text-warmwhite text-lg mb-1" data-id="element-424">
                    The Complete Anger Circuit Breaker PDF Guide
                  </h4>
                  <p className="font-inter text-softgray text-sm md:text-base leading-relaxed" data-id="element-425">
                    Step-by-step instructions for the 55-Second Oxygen Pulse
                    Sequence — explained so clearly you can use it the first
                    time you read it.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-426">
                <div className="mt-1 bg-teal-900/30 rounded-full p-1 mr-4 shrink-0" data-id="element-427">
                  <CheckIcon className="w-5 h-5 text-teal-400" data-id="element-428" />
                </div>
                <div data-id="element-429">
                  <h4 className="font-inter font-semibold text-warmwhite text-lg mb-1" data-id="element-430">
                    The Digital Action Cards (Mobile-Optimized)
                  </h4>
                  <p className="font-inter text-softgray text-sm md:text-base leading-relaxed" data-id="element-431">
                    Save them to your phone. Pull them up mid-argument. One
                    glance is all you need to start the sequence.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-432">
                <div className="mt-1 bg-teal-900/30 rounded-full p-1 mr-4 shrink-0" data-id="element-433">
                  <CheckIcon className="w-5 h-5 text-teal-400" data-id="element-434" />
                </div>
                <div data-id="element-435">
                  <h4 className="font-inter font-semibold text-warmwhite text-lg mb-1" data-id="element-436">
                    The Anger Trigger Map
                  </h4>
                  <p className="font-inter text-softgray text-sm md:text-base leading-relaxed" data-id="element-437">
                    Identify your personal anger patterns so you can intercept
                    rage before it starts — not after.
                  </p>
                </div>
              </li>
            </ul>

            {/* Delivery Info Box */}
            <div className="bg-midnight-light border border-white/10 rounded-xl p-6 flex flex-col sm:flex-row gap-4 sm:gap-8 justify-between items-start sm:items-center" data-id="element-438">
              <div className="flex items-center text-softgray font-inter text-sm" data-id="element-439">
                <MailIcon className="w-5 h-5 text-rosegold mr-3 shrink-0" data-id="element-440" />
                <span data-id="element-441">
                  Delivered instantly
                  <br data-id="element-442" />
                  to your email
                </span>
              </div>
              <div className="flex items-center text-softgray font-inter text-sm" data-id="element-443">
                <SmartphoneIcon className="w-5 h-5 text-rosegold mr-3 shrink-0" data-id="element-444" />
                <span data-id="element-445">
                  Works on any device
                  <br data-id="element-446" />
                  phone, tablet, computer
                </span>
              </div>
              <div className="flex items-center text-softgray font-inter text-sm" data-id="element-447">
                <LockIcon className="w-5 h-5 text-rosegold mr-3 shrink-0" data-id="element-448" />
                <span data-id="element-449">
                  One-time payment
                  <br data-id="element-450" />
                  yours forever
                </span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}